// extracted by mini-css-extract-plugin
module.exports = {"randomizedLoaderContainer":"XG8eu"};